import Noty from 'noty';
import './notification.scss';

const defaultOptions = {
  timeout: 5000,
  animation: {
    open: 'noty_animated-in',
    close: 'noty_animated-out',
  },
};

const error = (text, options) => (
  new Noty({
    ...defaultOptions,
    ...options,
    text,
    type: 'error',
  }).show()
);

const success = (text, options) => (
  new Noty({
    ...defaultOptions,
    ...options,
    text,
    type: 'success',
  }).show()
);

const notification = {
  error,
  success,
};

export default notification;
